<template>
  <v-container>
    <v-layout wrap class="mt-4">
      <v-row align="center" justify="end">
        <v-btn
          v-if="logged"
          color="primary"
          class="content"
          @click="changePage(getProject.project_id, getProject.visibility)"
          >+/- Contribuidores</v-btn
        >
      </v-row>
      <v-flex xs12 class="pt-4">
        <v-card
          v-for="cont in contributorsList"
          :key="cont.full_name"
          class="pt-3"
        >
          <v-card-title>
            {{ cont.full_name }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <strong class="text body-1 pl-2 font-weight-bold"
                >Institucion:
              </strong>
              <span> {{ cont.institute }} </span>
            </v-row>
            <v-row>
              <strong class="text body-1 pl-2 font-weight-bold">Tags: </strong>
              <span> {{ cont.tags }} </span>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <!--SnackBar for errors-->
    <v-snackbar v-model="snackbar" :right="true" :timeout="3000" :top="true">
      {{ messageSnack }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { auth, firestore } from "firebase";

export default {
  data() {
    return {
      projectId: undefined,
      messageSnack: "",
      snackbar: false,
      contributorsList: [],
      id_contributors: [],
      logged: false
    };
  },

  computed: {
    ...mapGetters("projects", ["getProject"])
  },

  mounted() {
    const currentUser = auth().currentUser;
    if (currentUser !== null) {
      // get full_name of user
      firestore()
        .collection("User")
        .doc(currentUser.uid)
        .onSnapshot(result => {
          const data = result.data();
          let first_name = data.first_name ? data.first_name : "";
          let last_name = data.last_name ? data.last_name : "";
          let full_name_user = (first_name + " " + last_name).trim();
          if (full_name_user == this.getProject.owner.full_name)
            this.logged = true;
        });
    }

    this.getProject.contributors.forEach(contributor => {
      // get ids of contributors
      firestore()
        .collection("User")
        .where("email.primary", "==", contributor.email)
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            this.id_contributors.push(doc.id);
            if (
              this.id_contributors.length ===
              this.getProject.contributors.length
            ) {
              getContributorsInf();
            }
          });
        });
    });
    // eslint-disable-next-line no-console
    console.log(this.contributorsList);

    const getContributorsInf = () => {
      this.id_contributors.forEach(user => {
        firestore()
          .collection("User")
          .doc(user)
          .onSnapshot(result => {
            const data = result.data();
            let first_name = data.first_name ? data.first_name : "";
            let last_name = data.last_name ? data.last_name : "";
            let full_name_user = first_name + " " + last_name;
            data.full_name = full_name_user;
            data.institute = data.education && data.education.length
              ? data.education[0].organization
              : "Desconocido";
            data.tags = data.tags ? this.filterTag(data.tags) : "Desconocidos";
            this.contributorsList.push(data);
          });
      });
    };
  },

  methods: {
    filterTag(tag) {
      if (tag && tag.length) {
        return tag.reduce((x, y) => {
          return " " + x + " , " + y;
        });
      } else {
        return "";
      }
    },
    changePage(project_id, visibility) {
      this.$router.push({
        path: `/dashboard/contributors/${project_id}/${visibility}`
      });
    }
  }
};
</script>

<style>
.content {
  margin-right: 3px;
}
</style>
